import React, { useEffect, useState } from "react";
import {
  Column,
  WrapperCard,
  WrapperContent,
  WrapperSubHeader,
  Row,
  DialogComponent,
  Wrapper,
} from "../../../components/common/index";
import { ContactDetailsContainer } from "./ContactDetailsContainer.tsx";
import { IoMdArrowBack } from "react-icons/io";
import { FaFileImport } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { FaUpload, FaRegFilePdf, FaRegEdit, FaPlus } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { Tooltip } from "@mui/material";
import Tabination from "../../../components/common/tabs/Tabination.tsx";
import {
  contactDetailTabs,
  supplierDetailTabs,
  transportDetailTabs,
} from "../../../components/tabs/contactDetailTabs.ts";
import GeneralDetailsData from "./GeneralDetailsData/GeneralDetailsData.tsx";
import { axiosFunction } from "../../../components/commonFunctions/index.ts";
import { v2ReactURL } from "../../../utils/constant.ts";
import { useDispatch, useSelector } from "react-redux";
import { setGeneralDetailsData } from "../../../store/Contact/generalDetailsSlce.ts";
import AddressDetailsData from "./AddressDetailsData/AddressDetailsData.tsx";
import ProductImportExcel from "../../../assets/demoFile/ProductImportExcel.xlsx";
import FileUploadDialogue from "../../../components/common/FileUploadDialogue/FileUploadComponent.tsx";
import { toastMessage } from "../../../components/commonFunctions/ToasterMessage.ts";
import { DeleteContactFunc } from "../../../components/commonFunctions/DeleteContactFunc.ts";
// import DebitNoteDataTable from "./DebitNoteDataTable/DebitNoteDataTable.tsx";
import CustomMenu from "../../../components/common/Menu/CustomMenu.js";
import useResponsive from "../../../hooks/useResponsive.ts";
import { SwalFunction } from "../../../components/commonFunctions/index.ts";
import BreadCrumbComponent from "../../../components/common/BreadCrumbComponent/BreadCrumbComponent.tsx";
import ErrorPage from "../../Error/ErrorPage.tsx";
import Loader from "../../../utils/Loader.tsx";
import { z } from "zod";
import { ErrorState } from "../MainDataTable.tsx";
import { ContactDetailsRelatedSchema } from "../../../hooks/ContactRelatedApiZodSchema.ts";
import { useDynamicMenuAction } from "../../../store/ContextApi/DynamicMenuActionContext.tsx";
import ContactDetailsDataTable from "./ContactDetailsDataTable/ContactDetailsDataTable.tsx";
import ledger from "../../../assets/images/main/ledger.svg"



export interface contactWiseDetailTabs {
  label: string,
  value: string,
  index: number,
}
const productSchema = z.array(z.object({
  data: z.string(),
  id: z.number(),
  itemCode: z.string(),
  mrp: z.string(),
  selling: z.string(),
  value: z.string(),
}));
export type productSchemaType = z.infer<typeof productSchema>;

const ContactDetails = () => {
  const contactType = useSelector((state: any) => state.contactType);
  const { dynamicMenuAction, setDynamicMenuAction } = useDynamicMenuAction();
  const navigate = useNavigate();
  const [dataLoading, setDataLoading] = useState<boolean>(true);
  const [tabView, setTabView] = useState<string>("General Details");
  const [openImportDialog, setOpenImportDialog] = useState<boolean>(false);
  const [openFileUploadDialog, setOpenFileUploadDialog] = useState<boolean>(false);
  const [file, setFile] = useState<File | string>("");
  const [fileName, setFileName] = useState<string>("");
  const [fileUploading, setFileUploading] = useState<boolean>(false);
  // const [isLoading, setIsloading] = useState(false)
  const dispatch = useDispatch();
  const params = useParams();
  const [imageFile, setImageFile] = useState<File | string>("");
  const [imageFileName, setImageFileName] = useState<string>("");
  const [imageUploading, setImageUploading] = useState<boolean>(false);
  const [imgLocationShow, setImgLocationShow] = useState<boolean>(false);
  const [loyaltyPoint, setLoyaltyPoint] = useState<number>(0);
  const [productData, setProductData] = useState<productSchemaType>([]);
  // const { contactRelatedData } = useContactRelatedApi(contactType);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  const sessionBranchId = sessionList?.branchId;
  // const sessionBranchId = 5989;
  const [verified, setVerified] = useState<boolean>(false);
  const isMobile = useResponsive();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [isBtnLoading, setIsBtnLoading] = useState<boolean>(false)
  const [error, setError] = useState<ErrorState | null>(null);
  const open = Boolean(anchorEl);
  // console.log("verified",verified)
  const handleClosePlusMenu = () => {
    setAnchorEl(null);
  };

  // console.log("loyaltyPoint",loyaltyPoint)
 
 
      const fetchProducts = async () => {
        const res = await axiosFunction(`${v2ReactURL}/product/jsondata`, "GET");
        const validatedData = productSchema.safeParse(res?.data?.response);
        if (validatedData.success) {
          setProductData(validatedData.data);
          setLoading(false);
        } else {
          console.error("API response validation failed:", validatedData.error);
        }
        if (
          res?.code == "ERR_NETWORK" ||
          res?.message == "network error"
        ) {
          setError({
            code: res?.code || "502",
            message:
              res.message ||
              "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon! ",
          });
          setLoading(false);
        } else if (res?.response?.status == 400) {
          setError({
            code: res?.response?.status || "400",
            message:
              res?.message ||
              "Oops, your request got lost in translation! Maybe try again with simpler instructions? ",
          });
          setLoading(false);
        } else if (res?.response?.status == 404) {
          setError({
            code: res?.response?.status || "404",
            message:
              res?.message ||
              "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
          });
        } else if (res?.response?.status == 500) {
          setError({
            code: res?.response?.status || "500",
            message:
              res?.message ||
              "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
          });
          setLoading(false);
        }
      };

      useEffect(() => {
        if (tabView === "product_list" && productData.length === 0) {
          fetchProducts();
        }
      }, [tabView]);
 
      useEffect(() => {
        // fetchProducts();
        setVerified(false);
      }, []);
        
   const contactGeneralDetails: ContactDetailsRelatedSchema = useSelector(
    (state: any) => state.contactGeneralDetails
  ) || [];
  // console.log("contactGeneralDetails",contactGeneralDetails)

  const filteredContactTabs = contactDetailTabs.reduce(
      (acc: contactWiseDetailTabs[], tab: contactWiseDetailTabs) => {
        if (
            (contactGeneralDetails?.allowcustomerwiseproductmapping !== 1 && tab.value === "product_list") ||
            (contactGeneralDetails?.loyalty !== 1 && tab.value === "Customer Loyalty Ledger")
        ) {
          return acc; // Skip this tab
        }
        return [...acc, tab]; // Keep the tab
      },
      []
  );

  const filteredSupplierTabs =
    contactGeneralDetails?.allowsupplierwiseproductmapping === 1
      ? supplierDetailTabs
      : supplierDetailTabs?.filter((tab: contactWiseDetailTabs) => tab.value !== "product_list");

  // const filteredCustomerTabs =

  const contactWiseDetailTabs: contactWiseDetailTabs[] =
    params.contactType === "customers"
      ? filteredContactTabs
      : params.contactType === "suppliers"
        ? filteredSupplierTabs
        : transportDetailTabs;

  const handleTabChange = (e: React.SyntheticEvent, value: string) => {
    e.preventDefault();
    setTabView(value);
  };

  const handleOpenFileUploadDialog = () => {
    setOpenFileUploadDialog(!openFileUploadDialog);
  };

  const handleBackBtn = () => {
    navigate("/reactcontact");
  };
  const fetchContactDetails = async () => {
    setDataLoading(true);
    try {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/${params.contactType}/${params.contactId}`,
        "GET"
      );

      if (res?.status == 200) {
        if (res?.data["error page"] === "accessdenied/accessdenied") {
          setError({
            code: "200",
            message:
              "Sorry, this area's VIP only. Your pass must've gotton lost in the mail.",
          });
        }

        if (res?.data["error-404"] === "error/error-404") {
          setError({
            code: "404",
            message:
              res?.message ||
              "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
          });
        }
        dispatch(setGeneralDetailsData(res?.data));
        if (res?.data?.loyalty === 1 && params.contactType === "customers") {
          getLoyaltyPoint();
        }
        setLoading(false);
      } else if (
        res?.code == "ERR_NETWORK" ||
        res?.message == "network error"
      ) {
        setError({
          code: res?.code || "502",
          message:
            res.message ||
            "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon! ",
        });
        setLoading(false);
      } else if (res?.response?.status == 400) {
        setError({
          code: res?.response?.status || "400",
          message:
            res?.message ||
            "Oops, your request got lost in translation! Maybe try again with simpler instructions? ",
        });
        setLoading(false);
      } else if (res?.response?.status == 404) {
        setError({
          code: res?.response?.status || "404",
          message:
            res?.message ||
            "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
        });
      } else if (res?.response?.status == 500) {
        setError({
          code: res?.response?.status || "500",
          message:
            res?.message ||
            "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
        });
        setLoading(false);
      }
    } catch (error) {
      toastMessage("Error fetching contact details", "error");
    } finally {
      setDataLoading(false);
    }
  };

  // const fetchContactDetails = async () => {
  //   setDataLoading(true);
  //   try {
  //     const res = await axiosFunction(
  //       `${v2ReactURL}/contact/${params.contactType}/${params.contactId}`,
  //       "GET"
  //     );

  //     const validatedData = ContactDetailsRelatedSchema.safeParse(res?.data);
  //     if (validatedData.success) {
  //       dispatch(setGeneralDetailsData(validatedData.data));
  //       setLoading(false);
  //     } else {
  //       console.error("API response validation failed:", validatedData.error);
  //     }
  //     if (res?.status == 200) {
  //       if (res?.data["error page"] === "accessdenied/accessdenied") {
  //         setError({
  //           code: "200",
  //           message:
  //             "Sorry, this area's VIP only. Your pass must've gotton lost in the mail.",
  //         });
  //       }

  //       if (res?.data["error-404"] === "error/error-404") {
  //         setError({
  //           code: "404",
  //           message:
  //             res?.message ||
  //             "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
  //         });
  //       }
  //     } else if (
  //       res?.code == "ERR_NETWORK" ||
  //       res?.message == "network error"
  //     ) {
  //       setError({
  //         code: res?.code || "502",
  //         message:
  //           res.message ||
  //           "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon! ",
  //       });
  //       setLoading(false);
  //     } else if (res?.response?.status == 400) {
  //       setError({
  //         code: res?.response?.status || "400",
  //         message:
  //           res?.message ||
  //           "Oops, your request got lost in translation! Maybe try again with simpler instructions? ",
  //       });
  //       setLoading(false);
  //     } else if (res?.response?.status == 404) {
  //       setError({
  //         code: res?.response?.status || "404",
  //         message:
  //           res?.message ||
  //           "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
  //       });
  //     } else if (res?.response?.status == 500) {
  //       setError({
  //         code: res?.response?.status || "500",
  //         message:
  //           res?.message ||
  //           "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
  //       });
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     toastMessage("Error fetching contact details", "error");
  //   } finally {
  //     setDataLoading(false);
  //   }
  // };

  const handleClose = () => {
    setFile("");
    setFileName("");
  };

  const handleOpenImportDialog = () => {
    setOpenImportDialog(!openImportDialog);
    setVerified(false);
    handleClose();
  };

  const handleSheetVerifyBtn = async () => {
    setIsBtnLoading(true); // Set loading to true before API call
  
    try {
      const response = await axiosFunction(
        `${v2ReactURL}/contact/${contactType}/${params.contactId}/product/check/excel`,
        "POST",
        { excelFile: file },
        true
      );
  
      // When flag true then below logic will run...
      if (response.data.response.msg === "success") {
        toastMessage(response.data.message, "success");
        // setOpenImportDialog(false);
        setVerified(true);
      } else {
        setFileUploading(false);
  
        // When data is empty in sheet then flag false and wrong sheet message will be displayed...
        toastMessage(response.data.response.msg, "error");
        setFileName("");
        setFile("");
      }
    } catch (error) {
      console.error("Error verifying sheet:", error);
      toastMessage("Something went wrong. Please try again.", "error");
    } finally {
      setIsBtnLoading(false); // Ensure loading is set to false after API response
    }
  };
  

  const handleUploadImageBtn = async () => {
    const response = await axiosFunction(
      `${v2ReactURL}/contact/${params.contactType}/imageupload/${params.contactId}`,
      "POST",
      { file: imageFile },
      true
    );

    // When flag true then below logic will run...
    if (response.data.status) {
      toastMessage(response.data.message, "success");
      setOpenFileUploadDialog(false);
      // fetchProducts();
      fetchContactDetails()
    } else {
      setImageUploading(false);
      toastMessage(response.data.response, "error");
      setImageFile("");
      setImageFileName("");
    }
    // window.location.reload();
  };


  const getLoyaltyPoint = async () => {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${params.contactId}/getloyaltypoint`,
      "GET"
    );

    setLoyaltyPoint(res?.data?.response);
  };
const fetchContactRelatedList = async (contactType: string) => {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/listing?type=${contactType}`,
        "GET"
      );

      setDynamicMenuAction(res.data);

    };
  useEffect(() => {
    fetchContactDetails();
   
  }, []);
useEffect(() => {
  fetchContactRelatedList(contactType);
}
, [contactType]);
  useEffect(() => {
    if(contactGeneralDetails.ContactDetails?.imgLocation){
      setImgLocationShow(true);
     } else {
      setImgLocationShow(false);
     }
  }, [contactGeneralDetails]);
  const handleDeleteCustomer = () => {
    const contactId = params?.contactId ? parseInt(params.contactId, 0) : 0;
    DeleteContactFunc([contactId], navigate, contactType,true);
  };

  if (dataLoading || !contactGeneralDetails) {
    return <Loader />;
  }
// console.log("contactGeneralDetails.ContactDetails",contactGeneralDetails?.ContactDetails?.firstName)
  const customerName = contactType === "customers" ?
   `${contactGeneralDetails?.ContactDetails &&
      contactGeneralDetails?.ContactDetails?.firstName
      ? contactGeneralDetails?.ContactDetails?.firstName
      : ""
    } ${contactGeneralDetails?.ContactDetails &&
      contactGeneralDetails?.ContactDetails?.lastName
      ? contactGeneralDetails?.ContactDetails?.lastName
      : ""
    }` : `${contactGeneralDetails?.ContactDetails &&
      contactGeneralDetails?.ContactDetails?.companyName
      ? contactGeneralDetails?.ContactDetails?.companyName
      : ""
    }`;

  const handleOpenPlusBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const menuItemStyle = {
    paddingLeft: "14px",
    paddingRight: "10px",
    paddingTop: "5px",
    color: "black",
  };

  const menuItems = () => {
    return contactType === "customers" ? (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <a
          style={menuItemStyle}
          href={`/sales/invoice/new?contactId=${params.contactId}`}
        >
          Invoice
        </a>
        <a
          style={menuItemStyle}
          href={`/receipt/new?contactId=${params.contactId}`}
        >
          Receive Payment
        </a>
        <a
          style={menuItemStyle}
          href={`/sales/creditnote/new?contactId=${params.contactId}`}
        >
          Make Credit Note
        </a>
      </div>
    ) : (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <a
          style={menuItemStyle}
          href={`/purchase/bill/new?contactId=${params.contactId}`}
        >
          Supplier Bill
        </a>
        <a
          style={menuItemStyle}
          href={`/payment/new?contactId=${params.contactId}`}
        >
          Make Payment
        </a>
        <a
          style={menuItemStyle}
          href={`/purchase/debitnote/new?contactId=${params.contactId}`}
        >
          Make Debit Note
        </a>
      </div>
    );
  };

  const handlePDFPreview = async () => {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/pdf/${params.contactId}`,
      "GET",
      null,
      false,
      "blob"
    );
    if (res.status == 202 ){
      window.location.href = `/contact/${contactType}/accessdenied`;
    } else {
      const url = window.URL.createObjectURL(new Blob([res.data]));
       const link = document.createElement("a");
       link.href = url;
   
       // Set filename based on file type
       link.setAttribute("download", "contact_info.pdf");
   
       // Trigger download
       document.body.appendChild(link);
       link.click();
    }

  };

  const handleUploadBtn = async () => {
    const result = await SwalFunction(
      "Are You Sure You Want To Upload Product Sheet?",
      "You Won't Be Able To Revert This!",
      "Yes, Upload It!",
      { icon: "warning" }
    );

    if (result.isConfirmed) {
      setIsBtnLoading(true)
      const response = await axiosFunction(
        `${v2ReactURL}/contact/${contactType}/${params.contactId}/product/upload/excel`,
        "POST",
        { excelFile: file },
        true
      );

      // When flag true then below logic will run...
      if (response.data.status) {
        setIsBtnLoading(false)
        toastMessage("Product Imported Successfully.", "success");
        setOpenImportDialog(false);
        fetchProducts();
        // window.location.reload();
      } else {
        setFileUploading(false);
     
        // When data is empty in sheet then flag false and wrong sheet message will be disaplyed...
        toastMessage(response.data.response.msg, "error");
        setFileName("");
        setFile("");
      }
    }
  };

  let showEditBtn = true;
  let showDeleteBtn = true;
  if (contactType === "customers") {
    showEditBtn = !!dynamicMenuAction?.Edit;
    showDeleteBtn = !!dynamicMenuAction?.Delete;
  } else if (contactType === "suppliers") {
    showEditBtn = !!!!dynamicMenuAction?.Edit;
    showDeleteBtn = !!dynamicMenuAction?.Delete;
  } else if (contactType === "transport") {
    showEditBtn = !!!!dynamicMenuAction?.Edit;
    showDeleteBtn = !!dynamicMenuAction?.Delete
  }
 

  const capitalizeFirstChar = (string: string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };
  if (error) {
    return <ErrorPage error={error} />;
  }

  

  return (
    !isLoading && (
      <Wrapper navUrl={`${customerName +" | "+ capitalizeFirstChar(params.contactType || '')}`}>
        <WrapperSubHeader>
          <Column md={8}></Column>
          <Column md={2}></Column>
          <Column md={2} className="pl-md-0 mt-1 mt-md-0"></Column>
        </WrapperSubHeader>

        <WrapperContent>
          <BreadCrumbComponent
            type={`${capitalizeFirstChar(params.contactType || '')}`}
          />
          <Row>
            <WrapperCard>
              <ContactDetailsContainer>
                <div className="details-page-top-btn">
                  <div className="left-side-btn">
                    <IoMdArrowBack
                      className="back-btn"
                      onClick={handleBackBtn}
                      size={24}
                    />
                    <span>{customerName}</span>
                  </div>
                  {/* {contactGeneralDetails?.ContactDetails[0]?.branchId ===
                    sessionBranchId && ( */}
                  <div className="right-side-btn">
                  <Tooltip title="General Ledger">
                      <a
                        href={`/report/general-ledger?contactId=${params.contactId}`}
                        target="_blank"
                        className="customBtn ledger btn-sm btn btn-white m-btn m-btn--icon m-btn--icon-only mr-1"
                      >
                        <img src={ledger} alt="ledger" />
                      </a>
                    </Tooltip>
                    {params.contactType !== "transport" &&
                      (params.contactType === "customers"
                        ? contactGeneralDetails?.allowcustomerwiseproductmapping === 1
                        : contactGeneralDetails?.allowsupplierwiseproductmapping === 1) && (
                        <Tooltip title="Import Product">
                          <button
                            onClick={handleOpenImportDialog}
                            className="customBtn btn-sm btn bg-blue"
                          >
                            <FaFileImport size={isMobile ? 14 : 16} />
                          </button>
                        </Tooltip>
                      )}

                    {!imgLocationShow && (
                      <Tooltip title="File Upload">
                        <button
                          onClick={handleOpenFileUploadDialog}
                          className="customBtn btn-sm btn bg-green"
                        >
                          <FaUpload size={isMobile ? 14 : 16} />
                        </button>
                      </Tooltip>
                    )}

                    <Tooltip title="PDF">
                      <button
                        onClick={handlePDFPreview}
                        className="customBtn btn-sm btn bg-yellow"
                      >
                        <FaRegFilePdf size={isMobile ? 14 : 16} />
                      </button>
                    </Tooltip>
                    {contactGeneralDetails.ContactDetails && contactGeneralDetails?.ContactDetails?.isdefault ===
                      0 && (
                        <>
                          {contactGeneralDetails?.ContactDetails?.isBranch ===
                            0 &&
                            contactGeneralDetails?.ContactDetails?.active ===
                            0 &&
                            contactGeneralDetails?.ContactDetails?.branchId ===
                            sessionBranchId &&
                            showEditBtn && (
                              <Tooltip title="Edit">
                                <button
                                onClick={() => {
                                  localStorage.removeItem("pinCodes");
                                  navigate(`/reactcontact/${params.contactId}/edit`);
                                }}
                                
                                  className="customBtn btn-sm btn bg-blue"
                                >
                                  <FaRegEdit size={isMobile ? 14 : 16} />
                                </button>
                              </Tooltip>
                            )}

                          {contactGeneralDetails?.ContactDetails?.isBranch ===
                            0 &&
                            contactGeneralDetails?.ContactDetails?.branchId ===
                            sessionBranchId &&
                            showDeleteBtn && (
                              <Tooltip title="Delete">
                                <button
                                  onClick={handleDeleteCustomer}
                                  className="customBtn btn-sm btn bg-red"
                                >
                                  <RiDeleteBin5Line size={isMobile ? 14 : 16} />
                                </button>
                              </Tooltip>
                            )}
                        </>
                      )}

                    {params.contactType !== "transport" && (
                      <Tooltip title="New">
                        <button
                          onClick={handleOpenPlusBtn}
                          className="customBtn btn-sm btn bg-blue"
                        >
                          <FaPlus size={isMobile ? 14 : 16} />
                        </button>
                      </Tooltip>
                    )}

                    <CustomMenu
                      menuItems={menuItems()}
                      openMenu={open}
                      handleClose={handleClosePlusMenu}
                      anchorEl={anchorEl}
                    />
                  </div>
                  {/* )} */}
                </div>

                <div className="details-tab">
                  <Tabination
                    tabs={contactWiseDetailTabs}
                    handleTabChange={handleTabChange}
                    tabView={tabView}
                  />
                  {tabView === "General Details" && (
                    <GeneralDetailsData
                      contactType={params.contactType || ''}
                      fetchContactDetails={fetchContactDetails}
                      setImgLocationShow={setImgLocationShow}
                      imgLocationShow={imgLocationShow}
                    />
                  )}
                  {tabView === "Address Details" && (
                    <AddressDetailsData
                      fetchContactDetails={fetchContactDetails}
                    />
                  )}

                  {tabView === "Invoice" && <ContactDetailsDataTable tabView={"invoice"} />}
                  {tabView === "Credit Note" && <ContactDetailsDataTable tabView={"creditNote"} />}
                  {tabView === "Receipt" && <ContactDetailsDataTable tabView={"receipt"} />}
                  {tabView === "Payment" && <ContactDetailsDataTable tabView={"payment"} />}
                  {tabView === "Expense" && <ContactDetailsDataTable tabView={"expense"}/>}
                  {tabView === "Customer Loyalty Ledger" && (
                    <ContactDetailsDataTable loyaltyPoint={loyaltyPoint} tabView={"customerLoyaltyLedger"} />
                  )}
                  {tabView === "Supplier Bill" && <ContactDetailsDataTable tabView={"supplierBill"}/>}
                  {tabView === "Debit Note" && <ContactDetailsDataTable tabView={"debitNote"} />}
                  {tabView === "product_list" && (
                    <ContactDetailsDataTable tabView={"productList"} productData={productData} openImportDialog={openImportDialog}/>
                  )}
                </div>
              </ContactDetailsContainer>
            </WrapperCard>
          </Row>
        </WrapperContent>
        <DialogComponent
          handleClose={() => setOpenImportDialog(!openImportDialog)}
          dialogTitle={"Upload Product Sheet"}
          openDialog={openImportDialog}
          uploadBtn={true}
          handleUploadBtn={handleUploadBtn}
          disabledUploadBtn={!verified}
          isLoading ={isBtnLoading}
          dialogContent={
            <FileUploadDialogue
              demoFile={ProductImportExcel}
              fileName={fileName}
              sheetImporting={true}
              setFileName={setFileName}
              setFile={setFile}
            />
          }
          handleSubmitBtn={() => handleSheetVerifyBtn()}
          disabledSubmitBtn={!file}
          loading={fileUploading}
        />
        <DialogComponent
          handleClose={() => setOpenFileUploadDialog(!openFileUploadDialog)}
          dialogTitle={"Attachment Upload"}
          openDialog={openFileUploadDialog}
          isLoading ={isBtnLoading}
          dialogContent={
            <FileUploadDialogue
              fileName={imageFileName}
              setFileName={setImageFileName}
              setFile={setImageFile}
            />
          }
          handleSubmitBtn={() => handleUploadImageBtn()}
          disabledSubmitBtn={!imageFile}
          loading={imageUploading}
          submitBtnName="Upload"
        />
      </Wrapper>
    )
  );
};

export default ContactDetails;
